/* eslint-disable react/jsx-fragments */
import { Button, Card, CardProps, Col, Divider, MenuProps, Row, Tooltip, Typography } from "antd";
import React, { FC, forwardRef } from "react";
import { getTagStyles } from "../../../helpers";
import { DotsMenuDropdown } from "../DotsMenuDropdown";
import { CardTag } from "./ui/CardTag";
import "./index.less";
import { useSelector } from "react-redux";
import { userSelector } from "src/store/user";

interface Tag {
  text: string;
  color: string;
}

interface Link {
  text: string;
  href?: string;
}

interface CustomCardProps extends CardProps {
  id: string;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  dropdownMenuItems: MenuProps["items"];
  width?: string | number;
  tags?: Tag[];
  links?: Link[];
  isOutlined?: boolean;
  footerContent?: React.ReactNode;
  onDropdownClick?: () => any;
  setDealToEdit?: () => any;
  onLinkClick?: (href: string) => any;
  ref?: any;
  deal?: boolean;
  team?: boolean;
  owner?: string;
  dropSpace?: boolean;
  isTeamMeeting?: boolean;
  canEdit?: boolean;
  // isTeamMeeting?: boolean;
}

export const CustomCard: FC<CustomCardProps> = forwardRef<HTMLDivElement, CustomCardProps>(
  (
    {
      id,
      title,
      description,
      width,
      tags,
      links,
      isOutlined,
      footerContent,
      dropdownMenuItems,
      onDropdownClick,
      dropSpace,
      onLinkClick,
      children,
      deal,
      setDealToEdit,
      team, // just for display
      isTeamMeeting,
      canEdit,
      owner,
      ...props
    },
    ref
  ) => {
    const { email } = useSelector(userSelector);
    return (
      <Card
        ref={ref}
        title={deal ? `Name: ${title}` : team ? `Team Title: ${title}` : `Meeting Title: ${title}`}
        onClick={setDealToEdit}
        extra={
          !!canEdit && (
            <span onClick={(e) => e.stopPropagation()} style={{ all: "unset", display: "contents" }}>
              <DotsMenuDropdown menuItems={dropdownMenuItems} onDropdownClick={onDropdownClick} />
            </span>
          )
        }
        className={"custom-card"}
        style={{ width: width ? width : "100%", border: isOutlined ? "1px solid #01AEEF" : "1px solid #FFFFFF", height: dropSpace ? "100%" : "default" }}
        {...props}
      >
        <Typography.Paragraph className={"card-menu-title"} style={{ marginBottom: "5px" }}>
          {" "}
          {!description ? "" : deal ? <>Description: {description || ""}</> : <>Meeting Description: {description || ""}</>}
        </Typography.Paragraph>
        {owner?.length > 2 ? (
          <Typography.Paragraph className={"card-menu-title"} style={{ fontWeight: 400, fontStyle: "italic", marginBottom: "-25px" }}>
            Team member: {owner[0].toUpperCase() + owner.slice(1)}
          </Typography.Paragraph>
        ) : (
          ""
        )}
        {children}
        <Divider className={"horizontal-divider"} />
        <Row justify={"space-between"}>
          {!footerContent && (
            <>
              <Col style={{ paddingLeft: 0, paddingRight: 0, margin: isTeamMeeting ? "auto" : 0 }}>
                <Row justify={"start"}>
                  {tags &&
                    tags.map((tag, index) => {
                      if (index === 2) {
                        return (
                          <Tooltip placement={"top"} title={tag.text === "Active link" ? `` : "Add team members to activate this link."}>
                            <div>
                              <CardTag
                                key={index}
                                value={tag.text}
                                color={getTagStyles(tag.color).color}
                                backgroundColor={getTagStyles(tag.color).backgroundColor}
                                smaller={isTeamMeeting}
                                // style={{ padding: 10 }}
                              />
                            </div>
                          </Tooltip>
                        );
                      } else {
                        return (
                          <CardTag
                            key={index}
                            value={tag.text}
                            color={getTagStyles(tag.color).color}
                            backgroundColor={getTagStyles(tag.color).backgroundColor}
                            smaller={isTeamMeeting}
                            // style={{ padding: 10 }}
                          />
                        );
                      }
                    })}
                </Row>
              </Col>
              {isTeamMeeting ? (
                <div style={{ paddingLeft: 0, paddingRight: 0, margin: "auto" }}>
                  <Row justify={"end"} align={"middle"} style={{ height: "100%" }}>
                    {/* {links &&
                      links.map((link, index) => ( */}
                    <React.Fragment>
                      <Tooltip
                        placement={"top"}
                        title={
                          <>
                            Specifically your link: <br />
                            <br />
                            Any prospect who books a meeting through this link will be tracked as a meeting booked by you ({email}) for the round robin link.{" "}
                            <br />
                            <br />
                            Side note: If you added the round robin link to your outreach campaign, this type of link is automatically used by Meetz in order to
                            track what meetings you booked.
                          </>
                        }
                      >
                        <Button
                          className={"link card-link"}
                          onClick={() => onLinkClick && onLinkClick(links?.[1]?.href || id)}
                          style={{ marginTop: "20px", marginLeft: 0, padding: 0 }}
                        >
                          Copy your link
                        </Button>{" "}
                      </Tooltip>
                      <Divider type={"vertical"} className={"vertical-divider"} style={{ marginTop: "20px", marginLeft: "20px" }} />{" "}
                      <Tooltip
                        title={
                          <>
                            Generic round robin link: <br />
                            <br />
                            Won't track who booked this meeting. Can be added to your website.
                          </>
                        }
                      >
                        <Button
                          className={"link card-link"}
                          onClick={() => onLinkClick && onLinkClick(links?.[0]?.href || id)}
                          style={{ marginTop: "20px", marginLeft: "20px", padding: 0 }}
                        >
                          General link
                        </Button>{" "}
                      </Tooltip>
                    </React.Fragment>
                    {/* ))} */}
                  </Row>
                </div>
              ) : (
                <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <Row justify={"end"} align={"middle"} style={{ height: "100%" }}>
                    {links &&
                      links.map((link, index) => (
                        <React.Fragment key={index}>
                          <Button className={"link card-link"} onClick={() => onLinkClick && onLinkClick(link.href || id)}>
                            {link.text}
                          </Button>
                          {index !== links.length - 1 && <Divider type={"vertical"} className={"vertical-divider"} />}
                        </React.Fragment>
                      ))}
                  </Row>
                </Col>
              )}
            </>
          )}
          {footerContent && footerContent}
        </Row>
      </Card>
    );
  }
);
